module.exports = __webpack_public_path__ + "static/media/feature3.60c29008.jpg";